module.exports = __webpack_public_path__ + "img/burger_menu_color.dbe47f15.svg";